import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../../directives/directives.module';
import { PopoverComponent } from './popover.component';

@NgModule({
  declarations: [PopoverComponent],
  exports: [PopoverComponent],
  entryComponents: [PopoverComponent],
  imports: [CommonModule, DirectivesModule]
})
export class PopoverModule {}

export { PopoverComponent };

export * from './popover.enums';
